module.exports = __webpack_public_path__ + "img/job-heavy.83861326.svg";